<template>
  <div class="wrapper copyright">
      <div v-if="isshow_hb">
          河北易之行网络科技有限公司<br />
          CopyRight © 2017 YixingAuto.com All Rights Reserved<br />
          冀ICP备17016416号-1
      </div>
      <div v-else-if="isshow_sd">
          山东赤兔文化传媒有限公司<br />
          CopyRight © 2017 ChituAuto.com All Rights Reserved<br />
          鲁ICP备18035235号-3
      </div>
      <div v-else-if="isshow_sx">
          山西易之行网络科技有限公司<br />
          CopyRight © 2017 YixingAuto.com All Rights Reserved<br />
      </div>
  </div>
</template>

<script>
    import getUrlKey from "../utils/_geturl";

    export default {
        name: "copyright",
        data(){
            return{
                isshow_hb: true,
                isshow_sd: false,
                isshow_sx: false
            }
        },
        created() {
            let base_url = window.location.host;
            if (base_url.indexOf("chitu") != -1){
                this.isshow_hb = false;
                this.isshow_sd = true;
                this.isshow_sx = false
            }
            let param_url = getUrlKey('copyright');
            if(param_url==1){
                this.isshow_hb = false;
                this.isshow_sd = false;
                this.isshow_sx = true
            }
            let activity_id = getUrlKey('activity_id');
            if(activity_id == 43){
                this.isshow_hb = false;
                this.isshow_sd = false;
                this.isshow_sx = false
            }
        }
    }
</script>

<style scoped lang="less">
@import "../assets/style/components/copyright";
</style>
